import React from "react";
var SortAsc = function SortAsc(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.08 11.78v.733a.3.3 0 0 1-.3.3H1.387a.3.3 0 0 1-.3-.3v-.733a.3.3 0 0 1 .3-.3H9.78a.3.3 0 0 1 .3.3ZM10.08 8.947v.733a.3.3 0 0 1-.3.3H3.37a.3.3 0 0 1-.3-.3v-.733a.3.3 0 0 1 .3-.3h6.41a.3.3 0 0 1 .3.3ZM10.08 6.113v.733a.3.3 0 0 1-.3.3H5.403a.3.3 0 0 1-.3-.3v-.733a.3.3 0 0 1 .3-.3H9.78a.3.3 0 0 1 .3.3ZM10.08 3.28v.733a.3.3 0 0 1-.3.3H7.403a.3.3 0 0 1-.3-.3V3.28a.3.3 0 0 1 .3-.3H9.78a.3.3 0 0 1 .3.3ZM13.914 10.308V3.28a.3.3 0 0 0-.3-.3h-.733a.3.3 0 0 0-.3.3v7.028h-1.376a.3.3 0 0 0-.234.487l2.042 2.553a.3.3 0 0 0 .469 0l2.042-2.553a.3.3 0 0 0-.234-.487h-1.376Z",
    fill: "#000",
    fillOpacity: ".5"
  }));
};
SortAsc.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "none"
};
var SortDesc = function SortDesc(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.08 12.797v.734a.3.3 0 0 1-.3.3H7.403a.3.3 0 0 1-.3-.3v-.734a.3.3 0 0 1 .3-.3H9.78a.3.3 0 0 1 .3.3Zm0-2.1v-.733a.3.3 0 0 0-.3-.3H5.403a.3.3 0 0 0-.3.3v.733a.3.3 0 0 0 .3.3H9.78a.3.3 0 0 0 .3-.3Zm0-3.566v.733a.3.3 0 0 1-.3.3H3.37a.3.3 0 0 1-.3-.3v-.733a.3.3 0 0 1 .3-.3h6.41a.3.3 0 0 1 .3.3Zm0-2.834v.734a.3.3 0 0 1-.3.3H1.387a.3.3 0 0 1-.3-.3v-.734a.3.3 0 0 1 .3-.3H9.78a.3.3 0 0 1 .3.3Z",
    fill: "#E20000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.58 6.503v7.028a.3.3 0 0 0 .3.3h.734a.3.3 0 0 0 .3-.3V6.503h1.376a.3.3 0 0 0 .234-.488l-2.042-2.553a.3.3 0 0 0-.469 0l-2.042 2.553a.3.3 0 0 0 .234.488h1.376Z",
    fill: "#E20000"
  }));
};
SortDesc.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  fill: "none"
};
import IconAtm from "../../../atoms/IconAtm";
import { SORT_STATUS } from "../HorizontalTableMol.types";
function SortIcon(_ref) {
  var status = _ref.status;
  switch (status) {
    case SORT_STATUS.ASC:
      return /*#__PURE__*/React.createElement(IconAtm, {
        icon: SortAsc,
        sizeSpace: 2,
        color: "primary",
        opacity: 1
      });
    case SORT_STATUS.DESC:
      return /*#__PURE__*/React.createElement(IconAtm, {
        icon: SortDesc,
        sizeSpace: 2,
        color: "primary"
      });
    default:
      return /*#__PURE__*/React.createElement(SortAsc, null);
  }
}
export default SortIcon;